import BaseBoosterBehavior, { IBaseBoosterBehaviorPlayMeta } from './BaseBoosterBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { IGameState } from '../../Game/IGameState';

export default class PlusThreeBoosterBehavior extends BaseBoosterBehavior {
    public play(state: IGameState, meta?: IBaseBoosterBehaviorPlayMeta): IGameState {
        let cardsState = {
            ...state.levelState.cardsState,
        };

        const targets: string[] = [];

        cardsState = CardStateHelper.addNewCards(cardsState, 3, targets);

        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.PLUS_THREE,
            cards: targets,
            cardsScore: [0],
        });

        state = {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState: cardsState,
            },
        };

        return this.consumeItemOrCoins(state);
    }
}
